import React from 'react';
import { Box } from '@mui/material';
import TypographyComponent from 'components/Typography/Typography';
import { pxToEm } from 'theme';
import palette from 'theme/palette';
import * as Styles from './ProductCard.styles';
import { ProjectDropdownVariant, ProjectProps } from './ProductCard.types';
import ProjectDropdown from './ProjectDropdown';

type AdvancedInfoHoverProps = {
  entityId?: string | number;
  isOvernight: boolean;
  isDigital: boolean;
  inStockLabel: string;
  outOfStockLabel: string;
  showOnHoverOnlyOvernight: boolean;
  projects: ProjectProps[];
  selectedProject: ProjectProps;
  projectPreLabel?: string;
  createProjectButtonLabel?: string;
  searchPlaceholderLabel?: string;
  onProjectClick?: (id: number) => void;
  onCreateProject?: () => void;
};

export function AdvancedInfoHover({
  entityId,
  isOvernight,
  isDigital,
  inStockLabel,
  outOfStockLabel,
  showOnHoverOnlyOvernight,
  projects,
  selectedProject,
  projectPreLabel,
  createProjectButtonLabel,
  searchPlaceholderLabel,
  onProjectClick,
  onCreateProject,
}: AdvancedInfoHoverProps) {
  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <Box display="flex" alignItems="center">
        {isOvernight && (
          <Styles.SubtextIcon name="overnight" size={0.66} dense />
        )}
        <TypographyComponent
          fontSize={pxToEm(10)}
          lineHeight={showOnHoverOnlyOvernight ? '20px' : '16px'}
          fontWeight={600}
          color={
            isOvernight || isDigital ? palette.info.main : palette.grey['A400']
          }
          textTransform="uppercase"
          noWrap
        >
          {isOvernight ? inStockLabel : outOfStockLabel}
        </TypographyComponent>
      </Box>
      {!showOnHoverOnlyOvernight && (
        <Styles.StaticProjectDropdownContainer>
          <ProjectDropdown
            entityId={entityId}
            variant={ProjectDropdownVariant.GHOST}
            projects={projects}
            selectedProject={selectedProject}
            preLabel={projectPreLabel}
            shouldShow
            isContained={false}
            hideAddToBag
            onProjectClick={onProjectClick}
            onCreateProject={onCreateProject}
            createProjectButtonLabel={createProjectButtonLabel}
            searchPlaceholderLabel={searchPlaceholderLabel}
          />
        </Styles.StaticProjectDropdownContainer>
      )}
    </Box>
  );
}
